
      import API from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4/node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/cjs.js??clonedRuleSet-4.use[1]!../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/stylePostLoader.js!../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/index.js??ruleSet[0]!./mobile-label-box.vue?vue&type=style&index=1&id=0bd62508&scoped=true&lang=css";
      
      

var options = {};

;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "#style-placeholder");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/cjs.js??clonedRuleSet-4.use[1]!../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/stylePostLoader.js!../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/index.js??ruleSet[0]!./mobile-label-box.vue?vue&type=style&index=1&id=0bd62508&scoped=true&lang=css";
       export default content && content.locals ? content.locals : undefined;
